import { Accordion, AccordionDetails, AccordionSummary } from '@interstate/components/AccordionGroup';
import { Box } from '@interstate/components/Box';
import React from 'react';
import { SingleTradeInFormProvider } from './TradeInFormProvider';
import { TradeInForm } from './TradeInForm';
import { MultiTradeInHeader } from './MultiTradeInHeader';
import { TradeInDeleteUndoIcon } from './TradeInDeleteUndoIcon';
import { MultiTradeInCollapsedView } from './MultiTradeInCollapsedView';
import { useLienholderFormData } from '../hooks/useLienholderFormData';

type TradeInAccordionProps = {
    formIndex: number;
    isExpanded: boolean;
    isDeleted: boolean;
    isEditDisabled: boolean;
    isTradeInFormDirtyRef?: React.MutableRefObject<boolean>;
    onContractingErrorsAlert?: (hasErrors: boolean) => void;
    onToggle: () => void;
};

export const TradeInAccordion = ({
    formIndex,
    isExpanded,
    isDeleted,
    isEditDisabled,
    isTradeInFormDirtyRef,
    onContractingErrorsAlert,
    onToggle
}: TradeInAccordionProps) => {
    const { lienholderData, setLienholderData } = useLienholderFormData(formIndex, isEditDisabled === true);

    return (
        <SingleTradeInFormProvider tradeInIndex={formIndex} onContractingErrorsAlert={onContractingErrorsAlert}>
            <Accordion
                key={formIndex}
                contained={true}
                onChange={onToggle}
                expanded={isExpanded}
                data-testid="multi-tradein-accordion"
                sx={{ height: '100%' }}
            >
                <AccordionSummary
                    chevronPosition="left"
                    sx={{
                        alignItems: 'flex-start'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            gap: '0.5rem'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <MultiTradeInHeader formIndex={formIndex} />
                            <TradeInDeleteUndoIcon
                                formIndex={formIndex}
                                isDeleted={isDeleted}
                                isExpanded={isExpanded}
                                isEditDisabled={isEditDisabled}
                            />
                        </Box>
                        {!isExpanded && (
                            <MultiTradeInCollapsedView
                                isEditDisabled={isEditDisabled || isDeleted}
                                tradeInIndex={formIndex}
                                lienholderData={lienholderData}
                                setLienholderData={setLienholderData}
                                isTradeInFormDirtyRef={isTradeInFormDirtyRef}
                            />
                        )}
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <TradeInForm
                        isEditDisabled={isEditDisabled || isDeleted}
                        lienholderData={lienholderData}
                        setLienholderData={setLienholderData}
                        isTradeInFormDirtyRef={isTradeInFormDirtyRef}
                    />
                </AccordionDetails>
            </Accordion>
        </SingleTradeInFormProvider>
    );
};
